import React from 'react';
import { ContextLayout } from '../../context-provider';
export default function IconWarnCircle(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$useCurrentColo = props.useCurrentColor,
      useCurrentColor = _props$useCurrentColo === void 0 ? true : _props$useCurrentColo,
      style = props.style;
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("svg", {
      className: prefixCls + "-icon " + prefixCls + "-icon-warn-circle " + className,
      width: "1em",
      height: "1em",
      style: style,
      fill: useCurrentColor ? "currentColor" : "#000000",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-22.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.8 15.2h.3c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7h-.3c-.4 0-.7.3-.7.7v7.3c0 .4.3.7.7.7zM12.2 16.5h-.3c-.4 0-.7.3-.7.7v.3c0 .4.3.7.7.7h.3c.4 0 .7-.3.7-.7v-.3c0-.4-.3-.7-.7-.7z"
    }));
  });
}